import { APPOINTMENT_TOUR_TARGET } from './onboardingAppointmentWizardTargets';

/** Alvos guiados do passo FIRST_COMPLETED_APPOINTMENT (ordem = fluxo do tour). */
export const APPOINTMENT_ONBOARDING_STEP_TARGETS = [
  {
    id: APPOINTMENT_TOUR_TARGET.CREATE,
    groupLabel: 'Agendamentos',
    hint: 'Clique em Novo Agendamento para abrir o formulário.',
    requiresInteraction: true,
  },
  {
    id: APPOINTMENT_TOUR_TARGET.CUSTOMER_CPF,
    groupLabel: '1 · Cliente',
    hint: 'Campo CPF (opcional): use para buscar o cliente no sistema. Pode deixar vazio ou informar um CPF que não exista — clique em Próximo para seguir.',
  },
  {
    id: APPOINTMENT_TOUR_TARGET.CUSTOMER_DETAILS,
    groupLabel: '1 · Cliente',
    hint: 'Preencha nome, sobrenome e celular com DDD. Todos são obrigatórios para continuar.',
  },
  {
    id: APPOINTMENT_TOUR_TARGET.CUSTOMER_CONTINUE,
    groupLabel: '1 · Cliente',
    hint: 'Quando os dados estiverem corretos, clique em Continuar.',
    requiresInteraction: true,
  },
  {
    id: APPOINTMENT_TOUR_TARGET.TYPE,
    groupLabel: '2 · Tipo',
    hint: 'Escolha Agendamento Normal (um atendimento) ou Recorrente (série de atendimentos).',
  },
  {
    id: APPOINTMENT_TOUR_TARGET.TYPE_CONTINUE,
    groupLabel: '2 · Tipo',
    hint: 'Clique em Continuar para escolher o serviço.',
    requiresInteraction: true,
  },
  {
    id: APPOINTMENT_TOUR_TARGET.WORK,
    groupLabel: '3 · Serviço',
    hint: 'Selecione o serviço que será realizado neste atendimento.',
  },
  {
    id: APPOINTMENT_TOUR_TARGET.WORK_CONTINUE,
    groupLabel: '3 · Serviço',
    hint: 'Clique em Continuar para escolher o profissional.',
    requiresInteraction: true,
  },
  {
    id: APPOINTMENT_TOUR_TARGET.PROFESSIONAL,
    groupLabel: '4 · Profissional',
    hint: 'Clique no profissional que fará o atendimento.',
    requiresInteraction: true,
  },
  {
    id: APPOINTMENT_TOUR_TARGET.ASSIGN_PROFESSIONAL,
    groupLabel: '4 · Profissional por serviço',
    hint: 'Para cada serviço, escolha qual profissional irá atender.',
  },
  {
    id: APPOINTMENT_TOUR_TARGET.ASSIGN_CONTINUE,
    groupLabel: '4 · Profissional por serviço',
    hint: 'Clique em Continuar para escolher a data.',
    requiresInteraction: true,
  },
  {
    id: APPOINTMENT_TOUR_TARGET.DATE,
    groupLabel: '5 · Data',
    hint: 'Clique em um dia disponível no calendário.',
    requiresInteraction: true,
  },
  {
    id: APPOINTMENT_TOUR_TARGET.TIME,
    groupLabel: '6 · Horário',
    hint: 'Escolha um horário disponível na lista.',
    requiresInteraction: true,
  },
  {
    id: APPOINTMENT_TOUR_TARGET.RECURRENCE,
    groupLabel: '7 · Recorrência',
    hint: 'Defina a frequência e a data final da série de atendimentos.',
  },
  {
    id: APPOINTMENT_TOUR_TARGET.RECURRENCE_CONTINUE,
    groupLabel: '7 · Recorrência',
    hint: 'Clique em Continuar para revisar o agendamento.',
    requiresInteraction: true,
  },
  {
    id: APPOINTMENT_TOUR_TARGET.CONFIRM_REVIEW,
    groupLabel: '8 · Confirmação',
    hint: 'Revise cliente, serviço, profissional, data e horário.',
  },
  {
    id: APPOINTMENT_TOUR_TARGET.CONFIRM_SUBMIT,
    groupLabel: '8 · Confirmação',
    hint: 'Clique em Confirmar Agendamento para salvar.',
    requiresInteraction: true,
  },
  {
    id: APPOINTMENT_TOUR_TARGET.LIST,
    groupLabel: '9 · Finalizar',
    hint: 'Agendamento criado! Ele aparece aqui com status Agendado. Depois do horário do atendimento, use Concluir na linha. Avance quando quiser para o próximo passo do tour.',
    advanceToNextStepOnFinish: true,
  },
];
